module.exports = __webpack_public_path__ + "static/RTR_WP-2-Improved-Throughput-840a4e013140865589d65eacc8067874.pdf";